var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconCupom = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 22,
  viewBox: "0 0 24 22",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_8065",
  "data-name": "Group 8065",
  transform: "translate(219.724 26.385)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_5537",
  "data-name": "Path 5537",
  transform: "translate(-219.724 -26.385)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_5646",
  "data-name": "Caminho 5646",
  d: "M-195.886-16.212l-1.667-3.017-.154.1a1.885,1.885,0,0,1-1.418.2,1.913,1.913,0,0,1-1.158-.877l-.035-.072a2.079,2.079,0,0,1,.709-2.764l.142-.084-1.655-3.017a1.2,1.2,0,0,0-.709-.589,1.172,1.172,0,0,0-.922.1l-16.359,9.928a1.315,1.315,0,0,0-.449,1.743l1.667,3.029.154-.1a1.867,1.867,0,0,1,2.577.661l.035.072a2.073,2.073,0,0,1-.709,2.764l-.142.1,1.655,3a1.2,1.2,0,0,0,1.064.649,1.094,1.094,0,0,0,.567-.156l16.359-9.928A1.309,1.309,0,0,0-195.886-16.212Zm-4.622,2.6-.177-.325a.685.685,0,0,0-.957-.264.728.728,0,0,0-.248.986l.177.337L-213.2-5.924l-.981-1.8a3.627,3.627,0,0,0,.272-3.906,3.288,3.288,0,0,0-3.357-1.707l-.993-1.8,11.477-6.971.177.325a.685.685,0,0,0,.957.264.739.739,0,0,0,.248-.986l-.177-.337,3.321-2.007.993,1.8a3.585,3.585,0,0,0-.272,3.894,3.243,3.243,0,0,0,3.357,1.707l.993,1.815Z",
  transform: "translate(219.724 26.385)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path_5538",
  "data-name": "Path 5538",
  transform: "translate(-203.897 -17.651)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_5647",
  "data-name": "Caminho 5647",
  d: "M-204.642-16.764l-.049.024a.71.71,0,0,1-.316.073.75.75,0,0,1-.645-.365L-206.2-18a.733.733,0,0,1,.219-.973l.024-.061h.073a.818.818,0,0,1,.511-.049.812.812,0,0,1,.45.353l.547.961A.737.737,0,0,1-204.642-16.764Z",
  transform: "translate(206.299 19.107)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path_5539",
  "data-name": "Path 5539",
  transform: "translate(-205.72 -20.983)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_5648",
  "data-name": "Caminho 5648",
  d: "M-206.169-19.557l-.024.024a.766.766,0,0,1-.365.085.705.705,0,0,1-.632-.365l-.559-.961a.741.741,0,0,1,.255-1l.061-.036a.729.729,0,0,1,.961.292l.559.961A.741.741,0,0,1-206.169-19.557Z",
  transform: "translate(207.846 21.884)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path_5540",
  "data-name": "Path 5540",
  transform: "translate(-210.215 -18.928)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_5649",
  "data-name": "Caminho 5649",
  d: "M-210.273-19.122v7.906a.67.67,0,0,1-.665.679.682.682,0,0,1-.679-.679v-7.919a.67.67,0,0,1,.679-.665.633.633,0,0,1,.479.2A.622.622,0,0,1-210.273-19.122Z",
  transform: "translate(211.616 19.8)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path_5541",
  "data-name": "Path 5541",
  transform: "translate(-214.614 -16.648)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_5650",
  "data-name": "Caminho 5650",
  d: "M-211.187-16.626l-.306-.532a1.88,1.88,0,0,0-2.555-.692h-.013a1.91,1.91,0,0,0-.692,2.6l.306.532a1.832,1.832,0,0,0,1.131.878,2.183,2.183,0,0,0,.492.067,1.969,1.969,0,0,0,.945-.253l.013-.013A1.9,1.9,0,0,0-211.187-16.626Zm-2.116,1.185-.293-.492a.554.554,0,0,1,.2-.745.541.541,0,0,1,.732.186v.04h.027l.28.506a.545.545,0,0,1-.186.745.566.566,0,0,1-.413.053.531.531,0,0,1-.319-.24v-.053Z",
  transform: "translate(215.006 18.094)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path_5542",
  "data-name": "Path 5542",
  transform: "translate(-208.49 -16.237)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_5651",
  "data-name": "Caminho 5651",
  d: "M-206.427-16.3l-.306-.532a1.858,1.858,0,0,0-1.145-.878,1.845,1.845,0,0,0-1.424.186h-.013a1.918,1.918,0,0,0-.679,2.6l.293.532a1.886,1.886,0,0,0,1.637.932,1.9,1.9,0,0,0,.945-.253A1.915,1.915,0,0,0-206.427-16.3Zm-2.1,1.238-.013-.053h-.013l-.28-.492a.554.554,0,0,1,.2-.745.471.471,0,0,1,.4-.053.523.523,0,0,1,.333.24l.306.546a.53.53,0,0,1-.2.732A.534.534,0,0,1-208.53-15.066Z",
  transform: "translate(210.247 17.781)",
  fill: "#fff"
})))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCupom, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_cupom.68d71931.svg";
export { ForwardRef as ReactComponent };